import { Localized } from '../../localization/react'
import { Interval, isRepeatingShorterThanValidity, Repeating, UsageLimitPeriod } from '../../typings/Product'

function isUsageLimitPeriodExhausted(usageLimitPeriod?: UsageLimitPeriod | null): boolean {
  return Boolean(usageLimitPeriod && usageLimitPeriod.allowedBookings - usageLimitPeriod.usedBookings <= 0)
}

interface AssignedProductAdditionalInformationProps {
  additionalInformation?: string | null
  usageLimitPeriod?: UsageLimitPeriod | null
  repeating?: Repeating | null
  validityDuration?: Interval | null
}

// `additionalInformation` is free text from the backend, not a translation key, so it's passed
// as the `reason` param rather than as <Localized> content. The renewal sentence is only added
// when the reason is a used-up period, since `usageLimitPeriod` stays populated even when the
// product is otherwise invalid.
export const AssignedProductAdditionalInformation = ({
  additionalInformation,
  usageLimitPeriod,
  repeating = null,
  validityDuration = null,
}: AssignedProductAdditionalInformationProps) => {
  if (!additionalInformation) return null

  if (
    isUsageLimitPeriodExhausted(usageLimitPeriod) &&
    repeating &&
    isRepeatingShorterThanValidity(repeating, validityDuration)
  ) {
    return (
      <Localized
        id="assigned-product-usage-limit-period-reached-with-renewal"
        params={{ reason: additionalInformation, intervalType: repeating.interval.type as any }}
      />
    )
  }

  return <>{additionalInformation}</>
}
